import { render, staticRenderFns } from "./CustomerCreditDatabaseList.vue?vue&type=template&id=057064aa"
import script from "./CustomerCreditDatabaseList.vue?vue&type=script&lang=js"
export * from "./CustomerCreditDatabaseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports